import http from "@/utils/request";
import qs from 'qs'

/**
 * 活动信息接口
 * @param {*} id 
 * @returns  activeState 活动状态 0活动未开始，1提交作品阶段，2评审阶段，3活动结束
 */
export function getActiveDetail(id = 1) {
  return http.get(`/biz/dscommon/${id}`);
}